export default __webpack_public_path__ + "d49d5deed4db2e9d1379aae344d4fa4d.svg";